import React, { useState, useContext, useEffect, forwardRef } from 'react';
import { TextField, Button, Snackbar, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import MuiAlert from '@material-ui/lab/Alert';
import EmailIcon from '@material-ui/icons/Email';
import CancelIcon from '@material-ui/icons/Cancel'
import 'date-fns';
import moment from 'moment';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import { Theme } from '../contexts/themeContext.js';
import Grid from '@material-ui/core/Grid';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};


const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    flButton: {
        float: 'right'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    notAllowed: {
        cursor: 'not-allowed'
    },
    textBlod: {
        fontWeight: '600'
    },
    green: {
        backgroundColor: '#00b5ad',
        color: 'white',
        '&:hover': {
            backgroundColor: '#05a19a',
        }
    },
    mt10: {
        marginTop: '10px'
    },
    mb10: {
        maginBottom: '10px'
    }
}));

const DirectorActionAdd = forwardRef((props, ref) => {
    const classes = useStyles();
    const { rdoAccountVisitationSelected } = props;
    const { theme } = useContext(Theme);
    const [backDrop, setBackDrop] = useState(true);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [openEmailSuccess, setOpenEmailSuccess] = useState(false);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    const [followUpList, setFollowUpList] = useState([]);
   
    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const cancel = () => {
        props.parentCallback();
    }

    const save = () => {
        var emailFormat = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
        if (sessionStorage.getItem("isOffline") === "1") {
            setErrorMessage("Director Action is unavailable in Offline Mode. Please connect to the internet.");
            setOpenError(true);
            return;
        }

        if (rdoModel.RecipientsEmailId) {
            var isMatchRegex = emailFormat.test(rdoModel.RecipientsEmailId);
            if (isMatchRegex) {
                setRdoModel({ ...rdoModel, DraftSave: true });
                exportToPDF();
            }
            else {
                setErrorMessage("Please Enter valid Email Address");
                setOpenError(true);
            }
        }
        else {
            setErrorMessage("Please Enter Email Address");
            setOpenError(true);
        }
    };

    const exportToPDF = () => {
        setBackDrop(true);

        HttpService.post('/RDOAccountVisitation/RDOAccountVisitationExport', { RDOAccountVisitDto: rdoModel, FollowUpList: followUpList}).then((result) => {
            setBackDrop(false);
            if (result.error) {
                setErrorMessage("Something went wrong, please contact administrator.");
                setOpenError(true);
                return;
            }
            setOpenEmailSuccess(true);
        },
            (error) => {
                console.log(error);
                setBackDrop(false);
            });
    };

    const [rdoModel, setRdoModel] = useState({
        Id: rdoAccountVisitationSelected.Id,
        SiteId: rdoAccountVisitationSelected.SiteId,
        Director: rdoAccountVisitationSelected.Director,
        RDO: rdoAccountVisitationSelected.RDO,
        Account: rdoAccountVisitationSelected.SiteName === undefined ? rdoAccountVisitationSelected.Account : rdoAccountVisitationSelected.SiteName,
        AccountVisitDate: rdoAccountVisitationSelected.AccountVisitDateTimeString === undefined ? rdoAccountVisitationSelected.AccountVisitDate : rdoAccountVisitationSelected.AccountVisitDateTimeString,
        RDORating: rdoAccountVisitationSelected.RDORating,
        SectionsCompleted: rdoAccountVisitationSelected.SectionsCompleted,
        Item1Notes: rdoAccountVisitationSelected.Item1Notes,
        Item2Notes: rdoAccountVisitationSelected.Item2Notes,
        Item3Notes: rdoAccountVisitationSelected.Item3Notes,
        Item4Notes: rdoAccountVisitationSelected.Item4Notes,
        Item5Notes: rdoAccountVisitationSelected.Item5Notes,
        Item6Notes: rdoAccountVisitationSelected.Item6Notes,
        IsDraftSaved: rdoAccountVisitationSelected.IsDraftSaved,
        DraftSave: rdoAccountVisitationSelected.DraftSave,
        RecipientsEmailId: rdoAccountVisitationSelected.RecipientsEmailId
    })

    const getRDOSections = () => {
        setBackDrop(true);

        HttpService.post('/RDOAccountVisitation/GetRDOSections',
            rdoModel
        )
            .then((result) => {
                setBackDrop(false);
                if (result.error) {
                    return;
                }
                var sections = result.RDOAccountVisitSectionList;
                var _followUpList = [];
                sections.forEach((item) => {
                    if (item.CompleteInterviewFollowUp) _followUpList.push('• Client Engagement');
                    if (item.QAInspectionHPUFollowUp) _followUpList.push('• High Priority Unit QAs');
                    if (item.QAInspectionHCAHPSFollowUp) _followUpList.push('• HPC/HCAHPS QAs');
                    if (item.HousekeepingCartFollowUp) _followUpList.push('• Janitor Closet/Housekeeping Cart Compliance');
                    if (item.HygienaATPReportFollowUp) _followUpList.push('• Hygiena ATP Report Results');
                    if (item.OverallAccountAssessmentFollowUp) _followUpList.push('• Overall Account Assessment');
                    if (item.VerifyFollowingProperlyFollowUp) _followUpList.push('• Operational Integrity');
                    if (item.CrothallFinancialFollowUp) _followUpList.push('• Crothall Financials');
                    if (item.HospitalFinancialFollowUp) _followUpList.push('• Hospital Financials');
                    if (item.ContractualAccountabilitieFollowUp) _followUpList.push('• Contractual Accountabilities');
                    if (item.ClicentFeedbackFollowUp) _followUpList.push('• Client Feedback');
                });
                setFollowUpList(_followUpList);
            },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                });

    };

    useEffect(() => {
        getRDOSections();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<>
        <Backdrop className={classes.backdrop} id="directorActionAddBackdrop" open={backDrop}>
            <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
            <Alert onClose={closeErrorSnackbar} severity="error">
                {errorMessage}
            </Alert>
        </Snackbar>
        <Snackbar open={openEmailSuccess} autoHideDuration={3000} onClose={cancel} style={{ height: "100%" }}>
            <Alert onClose={cancel} severity="success">
                Email sent successfully.
            </Alert>
        </Snackbar>
        <div className={classes.root} autoComplete="off">
            <TextField size="small" fullWidth
                label="Recipient's Email"
                autoComplete="email"
                type="email"
                variant="outlined"
                className={classes.mt10}
                value={rdoModel.RecipientsEmailId}
                onChange={(e) => { setRdoModel({ ...rdoModel, RecipientsEmailId: e.target.value }) }}
                InputLabelProps={{
                    shrink: true,
                }}
            />
            <div>
               <b style={{ color: currentTheme.text }}>Date : </b><label style={{ color: currentTheme.text }}>{moment(rdoAccountVisitationSelected.AccountVisitDate).format("MM/DD/YYYY")}</label>
            </div>
            <div>
                <b>Director : </b><label style={{ color: currentTheme.text }}>{rdoModel.Director }</label>
            </div>
            <div>
                <b>Account : </b><label style={{ color: currentTheme.text }}>{rdoModel.Account }</label>
            </div>
            <div>
                {
                    rdoModel.RDORating >= 4 &&
                    <p ng-if="rdoAccountVisitationSelected.RDORating >= 4">
                        Attached please find my completed RDO Account Visitation Summary Report. I want to thank you again
                        for your continued focus on your account operations. I enjoyed touring your program and am leaving
                        feeling confident in our overall performance and current direction. More specifically, I was very pleased
                        with these components of your operations:
                    </p>
                }

                {
                    rdoModel.RDORating < 4 &&
                    <p ng-if="rdoAccountVisitationSelected.RDORating < 4">
                        Attached please find my completed RDO Account Visitation Summary Report. I want to thank you again
                        for your continued focus on your account operations. I'm leaving the account recognizing the positive
                        things we are doing on site. More specifically, I was pleased with these components of your operations:
                    </p>
                }
            </div>

            {
                !rdoModel.IsDraftSaved &&
                <div>
                    <Grid container
                        direction="row"
                        spacing={1}
                    >
                        <Grid item sm={6}>
                            <TextField
                                fullWidth
                                id="free-text-1"
                                label="Free text 1"
                                margin="dense"
                                variant="outlined"
                                value={rdoModel.Item1Notes}
                                onChange={(e) => { setRdoModel({ ...rdoModel, Item1Notes: e.target.value }) }}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                fullWidth
                                id="free-text-2"
                                label="Free text 2"
                                margin="dense"
                                variant="outlined"
                                value={rdoModel.Item2Notes}
                                onChange={(e) => { setRdoModel({ ...rdoModel, Item2Notes: e.target.value }) }}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                fullWidth
                                id="free-text-3"
                                label="Free text 3"
                                margin="dense"
                                variant="outlined"
                                value={rdoModel.Item3Notes}
                                onChange={(e) => { setRdoModel({ ...rdoModel, Item3Notes: e.target.value }) }}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                fullWidth
                                id="free-text-4"
                                label="Free text 4"
                                margin="dense"
                                variant="outlined"
                                value={rdoModel.Item4Notes}
                                onChange={(e) => { setRdoModel({ ...rdoModel, Item4Notes: e.target.value }) }}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                fullWidth
                                id="free-text-5"
                                label="Free text 5"
                                margin="dense"
                                variant="outlined"
                                value={rdoModel.Item5Notes}
                                onChange={(e) => { setRdoModel({ ...rdoModel, Item5Notes: e.target.value }) }}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                fullWidth
                                id="free-text-6"
                                label="Free text 6"
                                margin="dense"
                                variant="outlined"
                                value={rdoModel.Item6Notes}
                                onChange={(e) => { setRdoModel({ ...rdoModel, Item6Notes: e.target.value }) }}
                            />
                        </Grid>
                    </Grid>
                </div>
            }

            {
                rdoModel.IsDraftSaved &&
                <div>
                    <Grid container
                        direction="row"
                        spacing={1}
                    >
                        <Grid item sm={6}>
                            <span>{rdoModel.Item1Notes}</span>
                        </Grid>
                        <Grid item sm={6}>
                            <span>{rdoModel.Item2Notes}</span>
                        </Grid>
                        <Grid item sm={6}>
                            <span>{rdoModel.Item3Notes}</span>
                        </Grid>
                        <Grid item sm={6}>
                            <span>{rdoModel.Item4Notes}</span>
                        </Grid>
                        <Grid item sm={6}>
                            <span>{rdoModel.Item5Notes}</span>
                        </Grid>
                        <Grid item sm={6}>
                            <span>{rdoModel.Item6Notes}</span>
                        </Grid>
                    </Grid>
                </div>
            }
           
           
            <div>
                {
                    rdoModel.RDORating >= 4 &&
                    <p ng-if="rdoAccountVisitationSelected.RDORating >= 4">
                        Please make sure to thank your managers and staff for all their hard work and dedication as well. You
                        and your team's combined efforts are helping the hospital serve their patients at a very high level!
                    </p>
                }

                {
                    rdoModel.RDORating >= 4 &&
                    <p ng-if="rdoAccountVisitationSelected.RDORating >= 4">
                        In our effort to continually improve our outcomes and reinforce the value we provide our partners client,
                        I want to provide a reminder of the areas where I feel additional attention is needed to build upon our
                        current outcomes:
                    </p>
                }

                {
                    rdoModel.RDORating < 4 &&
                    <p ng-if="rdoAccountVisitationSelected.RDORating < 4">
                        As we discussed though, our operations are not performing at a level that you or I should feel confident
                        about. More specifically, these areas are of immediate concern:
                    </p>
                }
            </div>
            <div>
                <Grid container spacing={1}>
                    <Grid item sm={6}>
                        {
                            followUpList.filter((x, rowIndex) => rowIndex % 2 === 0).map((item, index) => {
                                return (
                                    <div key={item}>
                                        <span>{item}</span>
                                        <br />
                                    </div>
                                )
                            })
                        }
                    </Grid>
                    <Grid item sm={6}>
                        {
                            followUpList.filter((x, rowIndex) => rowIndex % 2 !== 0).map((item) => {
                                return (
                                    <div key={item}>
                                        <span>{item}</span>
                                        <br />
                                    </div>
                                )
                            })
                        }
                    </Grid>
                </Grid>
            </div>
            <div>
                {
                    rdoModel.RDORating >= 4 &&
                    <p ng-if="rdoAccountVisitationSelected.RDORating >= 4">
                        As we discussed, these are areas where we need to see improvement over the next 30 days. Please
                        keep me posted on the steps you are taking to drive stronger outcomes in these areas. If there is any
                        additional help or recommendations I can provide beyond those we discussed while together, please
                        don't hesitate to reach out. I'm happy to support you and your team anyway that I can.
                    </p>
                }

                {
                    rdoModel.RDORating < 4 &&
                    <p ng-if="rdoAccountVisitationSelected.RDORating < 4">
                        In order to reinforce the value our company should provide to help support effective care delivery, it is
                        important that we make improvement in these areas over the next 30 days. Please keep me posted on
                        the steps you are taking to drive stronger outcomes in these areas. If there is any additional help or
                        recommendations I can provide beyond those we discussed while together, please don't hesitate to
                        reach out. I'm here to support you and your team anyway that I can.
                    </p>
                }
                <p>Best regards,</p>
                <p><b>{rdoModel.RDO }</b></p>
            </div>
            <div>
                <Grid container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                    spacing={1}>
                    <Button 
                        variant="contained"
                        color="primary"
                        size="small"
                        className={classes.button}
                        style={{ background: currentTheme.secondary, width: "180px", marginRight: "10px" }}
                        startIcon={<EmailIcon />}
                        onClick={save}
                    >
                        {!rdoModel.IsDraftSaved ? 'Save & ' : ''} Send Email
                    </Button>
                    <Button                        
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.button}
                        style={{ width: "100px" }}
                        startIcon={<CancelIcon />}
                        onClick={cancel}
                        autoFocus
                    >
                        Cancel
                    </Button>
                </Grid>
            </div>
        </div>
    </>
    );
});
export default DirectorActionAdd;
